import React from 'react';
import {useTranslate} from "../../../system/useTranslate";
import {useDispatch, useSelector} from "react-redux";
import BoxHeader from "../../components/box-header";
import {Button} from "primereact/button";
import Icon from "../../../system/components/icon";
import {DataView} from "primereact/dataview";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";
import {setMessage} from "../../../system/app-slice";
import {copyWorkspaceMediaLink, downloadWorkspaceMedia} from "../../../system/private-media";
import WorkspaceMediaThumbnail from "../../../system/components/workspace-media-thumbnail";

function Attachments({attachments, onAddClicked, onDeleteClicked, deletingAttachmentId, disabled = false}) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const workspaceId = useSelector((state) => state.app.workspaceId);
    const ItemTemplate = (data)=>{
        return(
            <div className="p-1 w-full">
                <div className="flex p-2 align-items-center justify-content-between gap-2 border-round-xl surface-100 w-full">
                    <div className="flex align-items-center">
                        <WorkspaceMediaThumbnail
                            file={data}
                            workspaceId={workspaceId}
                            width={data.formats?.thumbnail?.width || "3rem"}
                            showImage={false}
                        />
                        <div className="flex flex-column">
                            <span className="text-2xs text-400">{data.name}</span>
                        </div>
                    </div>

                    <div className="flex align-items-center gap-2">
                        <Button className="text-xs p-1 px-3 border-round-lg" label={translate("download")} onClick={()=>downloadWorkspaceMedia(data, workspaceId).catch(()=>undefined)} icon={<Icon icon="mi mi:download" className="text-lg"/>}/>
                        <Button className="text-xs p-1 px-3 border-round-lg p-button-info p-button-outlined" onClick={async ()=>{
                            try {
                                await copyWorkspaceMediaLink(data, workspaceId);
                                dispatch(setMessage({severity:"info", content:translate("file-path-copied")}));
                            } catch {
                                // The shared API interceptor displays the access error.
                            }
                        }} label={translate("copy-link")} icon={<Icon icon="mi mi:link" className="text-lg"/>}/>
                        {onDeleteClicked && (
                            <Button
                                type="button"
                                aria-label={translate("delete")}
                                tooltip={translate("delete")}
                                icon="pi pi-trash"
                                loading={deletingAttachmentId === data.id}
                                disabled={disabled || deletingAttachmentId != null}
                                onClick={() => onDeleteClicked(data)}
                                className="p-button-danger p-button-text p-button-rounded"
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
    return(
        <div className="flex flex-column p-2 border-1 border-dashed border-300 border-round-3xl">
            <BoxHeader className="text-sm" title={translate("attachments")} left={<Button type="button" disabled={disabled || deletingAttachmentId != null} onClick={onAddClicked} icon={<Icon icon="mi mi:add" className="text-sm"/>} className="border-none shadow-none text-xs p-1 px-2 p-button-text gap-2" pt={{label:()=>({className:"font-normal"})}} label={translate("add-attachment")}/>}/>
            <DataView emptyMessage={<DatatableEmptyMessage/>} layout="list" value={attachments||[]} itemTemplate={ItemTemplate}/>
        </div>
    )
}

export default Attachments;
